import styled from 'styled-components';
import React from "react";
import HeroBackground from "./images/hero.png";
import ChartBackground from "./images/chart.png";
import Screen from "./images/screen.png";
import MissionBackground from "./images/mission.png";

// LOGO
import SnuCampusTown from "./images/snu_campus_town.png";
import SnuVenture from "./images/snu_venture.png";
import NaksungVenture from "./images/naksung_venture.png";
import SelectStar from "./images/select_star.png";
import HayanAI from "./images/hayan_ai.png";
import Poomang from "./images/poomang.png";
import NpxCapital from "./images/npx_capital.png";
import NpxTerraArk from "./images/npx_terraark.png";
import Songlim from "./images/songlim.png";
import Nonce from "./images/nonce.png";
import AjPark from "./images/ajpark.png";
import Elysia from "./images/elysia.png";
import GrapeLounge from "./images/grape_lounge.png";
import Synergy from "./images/synerge_tower.png";
import Neovalue from "./images/neovalue.png";
import Rsquare from "./images/rsquare.png";

import PropwaveFooterLogo from "./images/propwave-logo2.png";

function App() {
  return (
      <Container>
          <Hero>
            <b>공간과 사람이 이어지는 기술<br />
                PROPWAVE</b>
          </Hero>
          <Chart>
              <ChartContent>
                  <SubTitle>About us</SubTitle>
                  <MainContent align={"flex-start"}>
                      <div>
                          프롭웨이브는 주차장, 상가, 온라인 커뮤니티에 대한
                      </div>
                      <div>
                          데이터를 수집, 가공 및 정제하고 있습니다.
                      </div>
                  </MainContent>
                  <SubContent>
                      고객의 수요를 바탕으로 가장 문제를 푸는데 최적화된 기술을 만들어내는 것을 목표로 성장하는 중입니다.
                  </SubContent>
              </ChartContent>
          </Chart>
          <AppThumbnail>
            <ScreenContainer />
            <AppThumbnailContent>
                <SubTitle>About us</SubTitle>
                <MainContent align={"flex-end"}>
                    <div>
                        프롭웨이브는 부동산 및 커뮤니티 분야에서
                    </div>
                    <div>
                        플랫폼 및 기술적 솔루션을 개발하는 기업입니다.
                    </div>
                </MainContent>
                <SubContent align={"flex-end"}>
                    <div>
                        부동산 상담과 더불어 필요한 전문직 서비스를 연결해드리는 '집톡', 공동 주거 커뮤니티 관리 솔루션 '아파톡',
                    </div>
                    <div>
                        미국 부동산 투자 플랫폼 '헬리패드' 등을 만들고 있습니다.
                    </div>
                </SubContent>
            </AppThumbnailContent>
          </AppThumbnail>
          <Mission>
              <SubTitle>Mission</SubTitle>
              <MainContent align={"center"}>
                  <div><b>좋은 사람과 좋은 공간</b>이 있으면 사람은 계속 살아나갈 힘을 얻습니다.</div>
                  <div>프롭웨이브는 모든 소비자에게 좋은 사람과 좋은 공간을 <b>이어주기 위한 방법</b>을 고민하고 실행합니다.</div>
              </MainContent>
          </Mission>
          <History>
              <div>
                  <SubTitle>History</SubTitle>
                  <MainContent>프롭웨이브가 걸어온 길</MainContent>
              </div>
              <HistoryContainer>
                  <HistoryContent>
                      <HistoryTime>2021.1</HistoryTime>
                      <HistoryTitle>중소기업인증</HistoryTitle>
                  </HistoryContent>
                  <HistoryContent>
                      <HistoryTime>2021.2</HistoryTime>
                      <HistoryTitle>기업부설연구소 설립(선릉)</HistoryTitle>
                  </HistoryContent>
                  <HistoryContent>
                      <HistoryTime>2021.2</HistoryTime>
                      <HistoryTitle>서울대 캠퍼스타운 지원기업 선정</HistoryTitle>
                  </HistoryContent>
                  <HistoryContent>
                      <HistoryTime>2021.3</HistoryTime>
                      <HistoryTitle>낙성벤처창업센터 입주기업 선정</HistoryTitle>
                  </HistoryContent>
                  <HistoryContent>
                      <HistoryTime>2021.4</HistoryTime>
                      <HistoryTitle>
                          서울시 디지털 뉴딜 일자리<br />
                          지원사업 선정 (인공지능 데이터 가공)
                      </HistoryTitle>
                  </HistoryContent>
              </HistoryContainer>
          </History>
          <Partners>
              <div>
                  <SubTitle>Partner</SubTitle>
                  <MainContent color={"#000000"}>프롭웨이브와 함께하는 기업</MainContent>
              </div>
              <PartnerContent>
                  <img src={SnuCampusTown} />
                  <img src={SnuVenture} />
                  <img src={NaksungVenture} />
                  <img src={SelectStar} />
                  <img src={HayanAI} />
                  <img src={Poomang} />
                  <img src={NpxCapital} />
                  <img src={NpxTerraArk} />
                  <img src={Songlim} />
                  <img src={Nonce} />
                  <img src={AjPark} />
                  <img src={Elysia} />
                  <img src={GrapeLounge} />
                  <img src={Synergy} />
                  <img src={Neovalue} />
                  <img src={Rsquare} />
              </PartnerContent>
          </Partners>
          <Footer>
              <FooterContent>
                  <FooterLeft>
                      <FooterRow>
                          <PropwaveLogoContainer />
                      </FooterRow>
                      <Company>
                          <FooterRow>
                              (주)프롭웨이브  대표 김승현
                          </FooterRow>
                          <FooterRow>
                              010-2775-3120   |   minikkim@gmail.com   |   서울시 관악구 관악로1 서울대학교 32-1동 2층 프롭웨이브
                          </FooterRow>
                      </Company>
                  </FooterLeft>
                  {/*<FooterRight>*/}
                  {/*    서비스 팀문화*/}
                  {/*</FooterRight>*/}
              </FooterContent>
          </Footer>
      </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: AppleSDGothicNeoB00;
`;

const Hero = styled.div`
  width: 100vw;
  height: 100vh;
  background: url(${HeroBackground});
  background-size: cover;
  
  color: #ffffff;
  font-size: 56px;
  font-weight: 400;
  text-align: center;
  
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Chart = styled.div`
  width: 100vw;
  height: 100vh;
  background: url(${ChartBackground});
  background-size: cover;
  
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ChartContent = styled.div`
  display: flex;
  flex-direction: column;
  
  margin-left: 100px;
`;

const AppThumbnail = styled.div`
  width: 100vw;
  height: 100vh;
  background: #121417;
  
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

const AppThumbnailContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const ScreenContainer = styled.div`
  width: 315px;
  height: 634px;
  background: url(${Screen});
  background-size: cover;
`;

const Mission = styled.div`
  width: 100vw;
  height: 100vh;
  background: url(${MissionBackground});
  background-size: cover;
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const History = styled.div`
  width: 100vw;
  height: 100vh;
  
  display: flex;
  flex-direction: column;
  
  background-color: #121417;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  margin-top: 78px;
`;

const HistoryContent = styled.div`
  display: flex;
  flex-direction: column;
  
  text-align: center;
  
  margin-bottom: 40px;
`;

const HistoryTime = styled.div`
  color: #b4b4b4;
  font-size: 17px;
  margin-bottom: 5px;
`;

const HistoryTitle = styled.div`
  color: #ffffff;
  font-size: 17px;
`;

const Partners = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const PartnerContent = styled.div`
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   grid-template-rows: repeat(4, 1fr);
   grid-row-gap: 40px;
   grid-column-gap: 100px;
   
   margin-top: 175px;
`;

const Footer = styled.div`
  width: 100%;
  height: 276px;
  background-color: #575757;
  display: flex;
  flex-direction: row;  
  align-items: center;
`;

const FooterContent = styled.div`
  color: #b4b4b4;
  
  position: absolute;
  left: 20%;
  
  display: flex;
  flex-direction: row;
`;

const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const PropwaveLogoContainer = styled.div`
  background: url(${PropwaveFooterLogo});
  background-size: cover;
  
  width: 162px;
  height: 35px;
`

const Company = styled.div`
  
`;

const FooterRow = styled.div`
  margin-bottom: 20px;
`

const SubTitle = styled.div`
   color: #2977FF;
   font-size: 20px;
   font-weight: 400;
   margin-bottom: 15px;
`;

const MainContent = styled.div`
  color: ${props => props.color ? props.color : "#ffffff"};
  font-size: 36px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  align-items: ${props => props.align};
  margin-bottom: 15px;
  line-height: 50px;
`;

const SubContent = styled.div`
  color: #b4b4b4;
  font-size: 17px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  align-items: ${props => props.align};
  line-height: 25px;
`;

export default App;
